<template>
    <div>
        <div class="card card-default">
            <div class="card-header">
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <span> OAuth Clients </span>

                    <a class="action-link" tabindex="-1" @click="create"> Create New Client </a>
                </div>
            </div>

            <div class="card-body">
                <!-- Current Clients -->
                <p class="mb-0" v-if="clients.length === 0">You have not created any OAuth clients.</p>

                <table class="table table-responsive table-borderless mb-0" v-if="clients.length > 0">
                    <thead>
                        <tr>
                            <th>Client ID</th>
                            <th>Name</th>
                            <th>Secret</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(client, index) in clients" :key="index">
                            <!-- ID -->
                            <td style="vertical-align: middle">
                                {{ client.id }}
                            </td>

                            <!-- Name -->
                            <td style="vertical-align: middle">
                                {{ client.name }}
                            </td>

                            <!-- Secret -->
                            <td style="vertical-align: middle">
                                <code>{{ client.secret ? client.secret : '-' }}</code>
                            </td>

                            <!-- Edit Button -->
                            <td style="vertical-align: middle">
                                <a class="action-link" tabindex="-1" @click="edit(client)"> Edit </a>
                            </td>

                            <!-- Delete Button -->
                            <td style="vertical-align: middle">
                                <a class="action-link text-danger" @click="destroy(client)"> Delete </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Client Modal -->
        <client-form-modal v-model:visible="showClientModal" v-model:client="form" @saved="onSaved"></client-form-modal>
    </div>
</template>

<script>
import axios from '~/services/axios';
import { VxButton, VxInput, VxLabel, VxModal, VxSwal, VxToggle } from '@voxie/frontend-components';
import ClientFormModal from './ClientFormModal.vue';
import { throwSwalRequestError } from '~/utils/request';

export default {
    components: {
        ClientFormModal,
        VxToggle,
        VxInput,
        VxLabel,
        VxButton,
        VxModal,
    },

    /*
     * The component's data.
     */
    data() {
        return {
            showClientModal: false,

            clients: [],

            form: {
                name: '',
                redirect: '',
                confidential: true,
            },
        };
    },

    /**
     * Prepare the component (Vue 1.x).
     */
    ready() {
        this.prepareComponent();
    },

    /**
     * Prepare the component (Vue 2.x).
     */
    mounted() {
        this.prepareComponent();
    },

    methods: {
        /**
         * Prepare the component.
         */
        prepareComponent() {
            this.getClients();
        },

        /**
         * Get all of the OAuth clients for the user.
         */
        getClients() {
            axios.get('/oauth/clients').then((response) => {
                this.clients = response.data;
            });
        },

        create() {
            this.form = {
                name: '',
                redirect: '',
                confidential: true,
            };

            this.showClientModal = true;
        },

        /**
         * Edit the given client.
         */
        edit(client) {
            this.form = {
                id: client.id,
                name: client.name,
                redirect: client.redirect,
            };

            this.showClientModal = true;
        },

        onSaved() {
            this.getClients();
        },

        /**
         * Destroy the given client.
         */
        destroy(client) {
            VxSwal.fire({
                title: 'Delete Client',
                icon: 'danger',
                showCancelButton: true,
                confirmButtonColor: 'danger',
                confirmButtonText: 'Yes, Delete',
                html: `Are you sure you want to delete this client <strong class="vx-font-bold">"${client.name}"</strong>?`,
                preConfirm: () =>
                    axios
                        .delete('/oauth/clients/' + client.id)
                        .then(() => this.getClients())
                        .catch(throwSwalRequestError),
            });
        },
    },
};
</script>

<style scoped>
.action-link {
    cursor: pointer;
}
</style>
